module.exports = __webpack_public_path__ + "img/skinbox-spring-small.64e9743e.png";